module.exports = __webpack_public_path__ + "img/gear.ef0ff2ea.svg";